__turbopack_context__.v({
  "actions": "salt-module-scss-module__L79MVq__actions",
  "card": "salt-module-scss-module__L79MVq__card",
  "cards": "salt-module-scss-module__L79MVq__cards",
  "combo": "salt-module-scss-module__L79MVq__combo",
  "comboHeader": "salt-module-scss-module__L79MVq__comboHeader",
  "comboTitle": "salt-module-scss-module__L79MVq__comboTitle",
  "deal-in": "salt-module-scss-module__L79MVq__deal-in",
  "error": "salt-module-scss-module__L79MVq__error",
  "foolsDay": "salt-module-scss-module__L79MVq__foolsDay",
  "identity": "salt-module-scss-module__L79MVq__identity",
  "intro": "salt-module-scss-module__L79MVq__intro",
  "loginNote": "salt-module-scss-module__L79MVq__loginNote",
  "message": "salt-module-scss-module__L79MVq__message",
  "messageTitle": "salt-module-scss-module__L79MVq__messageTitle",
  "openCombo": "salt-module-scss-module__L79MVq__openCombo",
  "popularity": "salt-module-scss-module__L79MVq__popularity",
  "quantity": "salt-module-scss-module__L79MVq__quantity",
  "resultList": "salt-module-scss-module__L79MVq__resultList",
  "results": "salt-module-scss-module__L79MVq__results",
  "sectionLabel": "salt-module-scss-module__L79MVq__sectionLabel",
  "shortcuts": "salt-module-scss-module__L79MVq__shortcuts",
  "skipButton": "salt-module-scss-module__L79MVq__skipButton",
  "tally": "salt-module-scss-module__L79MVq__tally",
  "voteButton": "salt-module-scss-module__L79MVq__voteButton",
  "voting": "salt-module-scss-module__L79MVq__voting",
  "zones": "salt-module-scss-module__L79MVq__zones",
});
